import React, { useState } from 'react';

import { t } from '@/utility/localization';

import Input from '@/components/common/Form/Input';
import Modal from '@/components/common/Modal';
import NPLButton from '@/components/npl/NPLButton';

const AddSectionModal = (props) => {
  const { open, onClose, onSubmit } = props;
  const [formData, setFormData] = useState({
    title: '',
    description: ''
  });
  const [formError, setFormError] = useState({});

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // reset form errors
    setFormError((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form
    if (!formData.title) {
      setFormError({ title: t('please-enter-a-title') });
      return;
    }

    onSubmit(formData);
  };

  return (
    <Modal
      open={open}
      showCloseIcon
      onClose={onClose}
      customContainerClass="max-w-[680px]"
      customInnerClass="c-PortalContent-AddSectionModal !p-0"
      closeOnBackdropClick={false}>
      <div>
        <h3 className="flex h-56 items-center border-b-1 border-npl-neutral-light-solid-6 px-24 text-heading-xs font-semibold">
          {t('new-section')}
        </h3>
        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-24">
            <div>
              <label
                htmlFor="title"
                className="mb-6 text-label-md font-medium text-dark-1b">
                {t('name')}
              </label>
              <Input
                name="title"
                placeholder="Name your section"
                customInnerClassName="!text-14 !text-neutral-10 !border-1 !border-npl-neutral-light-solid-7 !rounded-8 w-full !bg-white-default"
                value={formData.title}
                onChange={handleFieldChange}
                error={formError.title}
              />
            </div>
            <div className="mt-24">
              <label
                htmlFor="description"
                className="mb-6 text-label-md font-medium text-dark-1b">
                {t('description')}
                <span className="ml-2 text-dark-1b text-opacity-50">
                  {t('optional')}
                </span>
              </label>
              <textarea
                name="description"
                placeholder="What is this section about?"
                className="w-full rounded-8 border-1 border-npl-neutral-light-solid-7 bg-white-default p-16 text-14 text-neutral-10"
                value={formData.description}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          {/* Cta */}
          <div className="flex h-64 items-center justify-end space-x-16 border-t-1 border-npl-neutral-light-solid-6 px-24">
            <NPLButton
              hierarchy="outline"
              onClick={onClose}
              buttonText={t('cancel')}
              type="button"
            />
            <NPLButton
              hierarchy="accent_primary"
              type="submit"
              buttonText={t('save')}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddSectionModal;
